import { ManufacturingOrder } from './manufacturing-order';
import { User } from './user';

export class ClaimedManufacturingOrder {

  constructor(
    public hash: string,
    public date: number,
    public manufacturingOrder: ManufacturingOrder,
    public user: User
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/claimed-manufacturing-order.ts